export default __webpack_public_path__ + "static/media/minus-circle.df00d45d.svg";